import { useTranslation } from 'react-i18next';
import { Whisper, Tooltip } from 'rsuite';
import { TableCell } from '@mui/material';
import {
  formatBalanceUi,
  removeMinusFromBalance,
} from '@utils/balance-helpers';

const amountClasses = { 0: 'positive-num', 2: '' };

export function BalanceAmountContent({ row }) {
  const { t } = useTranslation();
  const currency = row.currency_to || row.currency_from;

  return (
    <div className="balanceAmountCell">
      <Whisper
        placement="auto"
        controlId="control-id-click"
        trigger="click"
        speaker={
          <Tooltip className="balanceAmountCell__tooltip">
            {row.bank_to?.top_up_fee && (
              <p>
                <span>{row.bank_to.top_up_fee}%</span> {t('operation_fee')}
              </p>
            )}
            <p>
              <span>{formatBalanceUi(row.amount_from, row.currency_from)}</span>
            </p>
          </Tooltip>
        }
      >
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className={`dashed-btn fw-500 ${amountClasses[row.type] ?? 'negative-num'}`}
        >
          {formatBalanceUi(
            row.type === 2
              ? removeMinusFromBalance(row.amount_to)
              : row.amount_to,
            currency,
          )}
        </button>
      </Whisper>
      <p className="secondary-text">{currency}</p>
    </div>
  );
}

export default function BalanceAmountCell({ row }) {
  return (
    <TableCell>
      <BalanceAmountContent row={row} />
    </TableCell>
  );
}
